module.exports = __webpack_public_path__ + "assets/img/632200.fb28258a.png";